import React from 'react';
import { Feather } from 'lucide-react';

interface LogoProps {
  size?: 'small' | 'medium' | 'large';
  showText?: boolean;
}

const Logo: React.FC<LogoProps> = ({ size = 'medium', showText = true }) => {
  const sizeMap = {
    small: {
      container: 'h-8',
      icon: 24,
      text: 'text-xl'
    },
    medium: {
      container: 'h-12',
      icon: 32,
      text: 'text-2xl'
    },
    large: {
      container: 'h-16',
      icon: 48,
      text: 'text-3xl'
    }
  };

  return (
    <div className="flex items-center">
      <div className={`flex items-center justify-center bg-orange-500 ${sizeMap[size].container} aspect-square`}>
        <Feather size={sizeMap[size].icon} className="text-white" />
      </div>
      {showText && (
        <h1 className={`ml-3 font-semibold ${sizeMap[size].text} text-gray-800`}>
          Test Latino™
        </h1>
      )}
    </div>
  );
};

export default Logo;